import PropTypes from "prop-types";
import React from "react";

import { TextFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import {
  USERNAME_MAX_LENGTH,
  USERNAME_MIN_LENGTH,
  USERNAME_SCHEMA_FIELD_NAMES,
} from "./UsernameFormField.schema";

/**
 * UsernameFormField renders a TextFormField with a label and caption for username entry.
 */
export const UsernameFormField = (props) => {
  const {
    caption,
    className,
    componentProps = {},
    defaultValue,
    disabled,
    label,
    name,
    option,
    value,
  } = props;

  return <TextFormField {...getFormFieldProps()} />;

  function getFormFieldProps() {
    return {
      caption,
      className,
      componentProps: {
        "aria-label": props["aria-label"] ?? i18n("UsernameFormField__ARIA_LABEL"),
        defaultValue,
        maxLength: USERNAME_MAX_LENGTH,
        minLength: USERNAME_MIN_LENGTH,
        option,
        required: true,
        value,
        ...componentProps,
      },
      disabled,
      label: label ?? i18n("UsernameFormField__LABEL"),
      name: name ?? USERNAME_SCHEMA_FIELD_NAMES.USERNAME,
    };
  }
};

UsernameFormField.propTypes = {
  /** Provides additional accessibility description. */
  "aria-label": PropTypes.string,

  /** Content below the form field. */
  caption: PropTypes.node,

  /** Additional classes for positioning the component. */
  className: PropTypes.string,

  /** Additional props to be passed to the underlying component. */
  componentProps: PropTypes.object,

  /** Default field value. */
  defaultValue: PropTypes.string,

  /** Indicates whether the field is disabled. */
  disabled: PropTypes.bool,

  /** Content above the form field, used to identify the form field. */
  label: PropTypes.node,

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,

  /** String to control the form field input value. */
  value: PropTypes.string,
};
